import React, {Component} from 'react';
import PropTypes from 'prop-types';
import {connect} from 'react-redux';
import {requestAlbumCreation,requestAlbumUpdate} from '../../actions/album-actions';
import Button from '../../../common/components/button';
import Input from '../../../common/components/forms/input';

export class AlbumAddNew extends Component {
    constructor(props) {
        super(props);

        this.state = {
            title: (props.album == null || props.album.title == null) ? "" : props.album.title,
            description: (props.album == null || props.album.description == null) ? "" : props.album.description,
            saveButtonLabel: "Save",
            saveButtonDisabled: false
        };

        this.textChange = this.textChange.bind(this);
        this.createAlbum = this.createAlbum.bind(this);
    }

    componentDidMount() {
        this.albumNameInput && this.albumNameInput.focus();
    }

    componentDidUpdate() {
        if (this.state.title === ' ') {
            this.setState({title: ''});
        }
    }

    textChange(evt) {
        if (evt.target.value.match(/^\s/)) evt.target.value.replace(/^\s/, '');
        if (evt.target.value.length >= parseInt(evt.target.dataset.maxLength, 10)) return;

        let newTextObject = {};
        newTextObject[evt.target.dataset.stateName] = evt.target.value;
        this.setState(newTextObject);
    }

    createAlbum() {
        if (this.state.title.length < 1) {
            this.setState({emptyAlbumError: true})
            return;
        } else {
            this.setState({saveButtonLabel: "Saving ...", saveButtonDisabled: true})
            if(this.props.album == null) {
                const {createAlbumAction} = this.props;
                createAlbumAction(this.state.title, this.state.description);
            }else{
                const {requestAlbumUpdate} = this.props;
                requestAlbumUpdate(this.props.album.id, {title: this.state.title, description: this.state.description})
            }
            this.props.onCancel()
        }
    }

    render() {
        return (
            <div className="add-album-spacer">
                <form onSubmit={this.createAlbum}>
                    <div className="">
                        <label className="hidden" htmlFor="newAlbumName">New Album Title</label>
                        <input
                            id="newAlbumName"
                            className={this.state.emptyAlbumError ? 'form-text-input empty-error' : 'form-text-input'}
                            onKeyPress={e => e.key === 'Enter' && e.preventDefault()}
                            type="text"
                            data-state-name="title"
                            data-max-length={this.props.maxTitleLength}
                            placeholder={this.state.emptyAlbumError ? 'Please Enter an Album Name' : 'New Album Title'}
                            value={this.state.title}
                            onChange={this.textChange}
                            maxLength={this.props.maxTitleLength}
                            ref={el => { this.albumNameInput = el; }}
                        />
                    </div>
                    <div>
                        <label className="hidden" htmlFor="newAlbumDescription">Description</label>
                    </div>
                    <div>
						<textarea
                            id="newAlbumDescription"
                            data-state-name="description"
                            data-max-length={this.props.maxDescriptionLength}
                            placeholder="Description"
                            onChange={this.textChange}
                            maxLength={this.props.maxDescriptionLength}
                            value={this.state.description}
                        />
                        <div
                            className="dialog-character-remain">{`${250 - this.state.description.length} characters remaining`}</div>
                    </div>
                    <div className="btn-dialog-container">
                        <Button id="submit-button" buttonStyle="primary" className="btn-dialog"
                                buttonLabel={this.state.saveButtonLabel} disabled={this.state.saveButtonDisabled}
                                onClick={this.createAlbum}/>
                        <Button buttonStyle="secondary" className="btn-dialog" buttonLabel="Cancel"
                                onClick={this.props.onCancel}/>
                    </div>
                </form>
            </div>
        );
    }
}

AlbumAddNew.propTypes = {
    maxTitleLength: PropTypes.number,
    maxDescriptionLength: PropTypes.number,
    onCancel: PropTypes.func.isRequired,
    createAlbumAction: PropTypes.func.isRequired
};

AlbumAddNew.defaultProps = {
    maxDescriptionLength: 251,
    maxTitleLength: 251
};

const mapDispatchToProps = dispatch => {
    return {
        createAlbumAction: (title, description) => dispatch(requestAlbumCreation(dispatch, title, description)),
        requestAlbumUpdate: (id, updateData) => dispatch(requestAlbumUpdate(dispatch, id, updateData))

    };
};
const mergeProps = (stateProps, dispatchProps, ownProps) => {
    let props = {...stateProps,...dispatchProps,...ownProps}
    props.createAlbumAction=  ownProps.createAlbumAction || dispatchProps.createAlbumAction
    return props;
}

export default connect(null, mapDispatchToProps,mergeProps)(AlbumAddNew);



// WEBPACK FOOTER //
// ./src/album-view/components/dialog/album-add-new.jsx